import { z } from 'zod';

// Gedeelde basisvelden voor beide formulieren
const baseSchema = z.object({
  firstName: z.string().min(1, 'Voornaam is verplicht'),
  name: z.string().min(1, 'Achternaam is verplicht'),
  email: z.string().email('Ongeldig e-mailadres'),
  phone: z.string().min(1, 'Telefoonnummer is verplicht'),
  street: z.string().min(1, 'Straatnaam is verplicht'),
  houseNumber: z.string().min(1, 'Huisnummer is verplicht'),
  postalCode: z.string().min(1, 'Postcode is verplicht'),
  city: z.string().min(1, 'Woonplaats is verplicht'),
  country: z.string().optional(),
  bankAccount: z.string().min(1, 'IBAN is verplicht'),
  bankAscription: z.string().min(1, 'Tenaamstelling is verplicht'),
  acceptsTerms: z.literal(true, {
    errorMap: () => ({
      message: 'U dient akkoord te gaan met de privacy voorwaarden',
    }),
  }),
});

// Particulier formulier: altijd maandelijks
export const donateSchema = baseSchema.extend({
  monthlyAmount: z
    .number({ invalid_type_error: 'Bedrag is verplicht' })
    .positive('Bedrag moet groter zijn dan 0'),
});

// Zakelijk formulier: keuze in frequentie en bedrag
export const donateCompanySchema = baseSchema.extend({
  company: z.string().min(1, 'Bedrijfsnaam is verplicht'),
  frequency: z.enum(['monthly', 'quarterly', 'yearly'], {
    errorMap: () => ({ message: 'Kies een geldige frequentie' }),
  }),
  amount: z
    .number({ invalid_type_error: 'Bedrag is verplicht' })
    .positive('Bedrag moet groter zijn dan 0'),
});

// Hulpfunctie: geeft { success, data, errors } terug
export function validate(schema, body) {
  const result = schema.safeParse(body);
  if (result.success) {
    return { success: true, data: result.data, errors: null };
  }
  const errors = Object.fromEntries(
    result.error.errors.map((e) => [e.path[0], e.message]),
  );
  return { success: false, data: null, errors };
}
